import axios from "axios";

const API_ENDPOINT = process.env.REACT_APP_backend_url+"/public";
const PUBLIC_API_ENDPOINT = process.env.REACT_APP_public_url+"/public";

export const introSignInApi = async (payload) => {
  return await axios.post(API_ENDPOINT+ "/intro/signin", payload);
  // return await axios.post(PUBLIC_API_ENDPOINT + "/intro/signin", payload);
}

export const productListApi = async () => {
  return await axios.get(PUBLIC_API_ENDPOINT + "/product/list");
}

export const getSpecialTypeColorList = async () => {
  return await axios.get(PUBLIC_API_ENDPOINT + "/color?type=special");
}
